import { PaletteNames, UITypes } from 'LibNeo'

export enum ValidationRulesType {
	LENGTH = 'length',
	DIGITS = 'digits',
	SPECIALS = 'specials',
	UPLOWLETTERS = 'uplowletters',
}

export enum ValidationType {
	MAIN,
	NOT_EQUAL,
	SHORT_LENGTH,
	TOO_SIMPLE,
	VALID,
}
export const passwordConfig: Record<
	ValidationType,
	{
		description: string
		color?: PaletteNames
		colorIndex: number
		icon?: string
		type: UITypes
	}
> = {
	[ValidationType.MAIN]: {
		description: 'Надежный пароль содержит:',
		color: 'gray',
		colorIndex: 8,
		icon: 'shield-outline',
		type: UITypes.BLACK,
	},
	[ValidationType.SHORT_LENGTH]: {
		description: 'Пароль слишком короткий',
		color: 'pink',
		colorIndex: 5,
		icon: 'shield-off-outline',
		type: UITypes.DANGER,
	},
	[ValidationType.TOO_SIMPLE]: {
		description: 'Пароль слишком простой',
		color: 'pink',
		colorIndex: 5,
		icon: 'shield-off-outline',
		type: UITypes.DANGER,
	},
	[ValidationType.NOT_EQUAL]: {
		description: 'Пароли не совпадают',
		color: 'pink',
		colorIndex: 5,
		icon: 'shield-off-outline',
		type: UITypes.DANGER,
	},
	[ValidationType.VALID]: {
		description: 'Надежный пароль',
		color: 'emerald',
		colorIndex: 6,
		icon: 'shield-outline',
		type: UITypes.PRIMARY,
	},
}

export const passwordRules = [
	{
		key: ValidationRulesType.LENGTH,
		label: '12+',
		title: 'не менее 12 символов',
	},
	{
		key: ValidationRulesType.UPLOWLETTERS,
		label: 'Аа',
		title: 'строчные и прописные латинские буквы',
	},
	{
		key: ValidationRulesType.DIGITS,
		label: '123',
		title: 'цифры',
	},
	{
		key: ValidationRulesType.SPECIALS,
		label: '$.#',
		title: 'специальные символы',
	},
]

export const hasDigitsReg = /(?=.*\d)/g
export const hasSpecialReg = /(?=.*[\\/!?@#$%^&*:,()/_№{|}~;[\]<=>`'.+-])/g
export const hasLowerUpperReg =
	/^(?=.*[a-z])(?=.*[A-Z])[a-zA-Z\d\\/!?@#$%^&*:,()/_№{|}~;[\]<=>'.+-]+$/
export const hasLengthReg = /(?=.{12,})/
